<template>
  <div>
    <v-row>
      <v-col cols="6" sm="4">
        <b>{{ $t('message.report.totalInventoryValue') }}</b>
      </v-col>
      <v-col cols="6" sm="4">
         <b>{{ $t('message.layout.warehouse') }}</b>
      </v-col>
      <v-col cols="6" sm="4">
         <b>{{ $t('message.report.locations') }}</b>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" sm="4" class="pt-0">
        {{ inventoryObj.totalinventory | replaceDotWithComma }}
      </v-col>
      <v-col cols="6" sm="4" class="pt-0">
        {{ inventoryObj.totalwarehouses }}
      </v-col>
      <v-col cols="6" sm="4" class="pt-0">
        {{ inventoryObj.totallocations }}
      </v-col>
    </v-row>
    <v-simple-table dense class="bordered--table">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" v-for="(head, index) in headers" :key="index">{{ head.text }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in inventoryObj.inventoryrecords" :key="index">
            <td>{{ data.productnumber }}</td>
            <td>{{ data.productdescription }}</td>
            <td>{{ data.productgroupname }}</td>
            <td class="text-right">{{ data.mainsuppliername }}</td>
            <td class="text-right">{{ data.warehouse }}</td>
            <td class="text-right">{{ data.location }}</td>
            <td class="text-right">{{ data.available | replaceDotWithComma }}</td>
            <td class="text-right">{{ data.costprice | replaceDotWithComma }}</td>
            <td class="text-right">{{ data.totalinventory | replaceDotWithComma }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
export default {
  props: ['inventoryObj'],
  computed: {
    headers () {
      return [{
        text: this.$t('message.report.prodNo')
      }, {
        text: this.$t('message.customer.description')
      }, {
        text: this.$t('message.customer.productGroup')
      }, {
        text: this.$t('message.report.vendor')
      }, {
        text: this.$t('message.layout.warehouse')
      }, {
        text: this.$t('message.layout.location')
      }, {
        text: this.$t('message.product.available')
      }, {
        text: this.$t('message.product.costPrice')
      }, {
        text: this.$t('message.report.totalInventory')
      }]
    }
  }
}
</script>
